import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { ProjectGrid } from '../components/ProjectGrid';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
export function Home() {
  return <div className="min-h-screen bg-black text-white selection:bg-yellow-400 selection:text-black" data-id="element-227">
      <SEO title="KUJODO Studio | Jasa Desain Branding & Logo Cimahi, Bandung" description="KUJODO Studio adalah creative studio di Cimahi, Bandung. Kami menyediakan jasa desain branding, logo, packaging, dan digital untuk bisnis Anda. Studio desain terpercaya di Cimahi dan Bandung." keywords="jasa desain Cimahi, jasa desain Bandung, studio desain Cimahi, studio desain Bandung, branding Cimahi, branding Bandung, desain logo Cimahi, desain logo Bandung, creative studio Bandung, creative studio Cimahi, jasa branding Bandung, desain packaging Bandung, KUJODO Studio" canonical="https://kujodo.id" data-id="element-228" />
      <Navigation data-id="element-229" />
      <main data-id="element-230">
        <Hero data-id="element-231" />
        <ProjectGrid data-id="element-232" />
        {/* Services Teaser */}
        <section className="py-24 px-6 border-t border-white/10" data-id="element-233">
          <div className="max-w-7xl mx-auto" data-id="element-234">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-235">
              <div className="p-8 border border-white/10 hover:border-yellow-400 transition-colors group" data-id="element-236">
                <h3 className="text-2xl font-bold mb-4 group-hover:text-yellow-400 transition-colors" data-id="element-237">
                  Branding
                </h3>
                <p className="text-gray-400" data-id="element-238">
                  Visual identity, strategy, and guidelines for modern brands.
                </p>
              </div>
              <div className="p-8 border border-white/10 hover:border-yellow-400 transition-colors group" data-id="element-239">
                <h3 className="text-2xl font-bold mb-4 group-hover:text-yellow-400 transition-colors" data-id="element-240">
                  Digital
                </h3>
                <p className="text-gray-400" data-id="element-241">
                  Web design, development, and interactive experiences.
                </p>
              </div>
              <div className="p-8 border border-white/10 hover:border-yellow-400 transition-colors group" data-id="element-242">
                <h3 className="text-2xl font-bold mb-4 group-hover:text-yellow-400 transition-colors" data-id="element-243">
                  Content
                </h3>
                <p className="text-gray-400" data-id="element-244">
                  Art direction, photography, and motion design.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-245" />
    </div>;
}